import React from "react";
import { formatElapsedTimenew } from "../../../services/common.utils";
import sampleUser from '../../../static/sampleUser.json'
const ResourceDataDisplay = ({ data }) => {
  const { active_timeclock_segments = [] } = data;

  // Group data by type_name
  const groupedByType = active_timeclock_segments.reduce((acc, segment) => {
    const { type_name } = segment;
    if (!acc[type_name]) acc[type_name] = [];
    acc[type_name].push(segment);
    return acc;
  }, {});

  return (
    <div className="mt-4">
      {Object.entries(groupedByType).map(([typeName, segments]) => (
        <div key={typeName} className="mb-5">
          <h2 className="text-primary mb-3 text-capitalize">{typeName}</h2>
          <div className="row">
            {segments?.map((segment, index) => (
              <div key={index} className="col-md-2 mb-4">
                <div className="text-center h-100 pt-2" style={{boxShadow: 'rgba(17, 17, 26, 0.1) 0px 0px 16px', borderRadius: 30}}>
                  <img
                    src={segment.image_url}
                    alt={segment.resource_name}
                    style={{ height: "100px", objectFit: "contain", borderRadius: '50%', boxShadow: 'rgba(136, 165, 191, 0.48) 6px 2px 16px 0px, rgba(255, 255, 255, 0.8) -6px -2px 16px 0px' }}
                  />
                  <div className="text-center p-2">
                      <h5 className="card-title">{segment.resource_name}</h5>
                    <p className="card-text text-capitalize">
                      {/* <strong>Role:</strong> */}
                     {segment.role_name}</p>
                    <p className="card-text text-capitalize">
                      {/* <strong>Segment:</strong> */}
                       {segment.segment_name}</p>
                   {!segment.elapsed_seconds && <p className="card-text">
                      {/* <strong>Start Time:</strong>  */}
                      {new Date(segment.start_time).toLocaleString()}
                    </p>}
                    <p className="card-text">
                      {/* <strong>Elapsed Seconds:</strong>  */}
                      {segment.elapsed_seconds ? formatElapsedTimenew(segment.elapsed_seconds) : '00:00:00'}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};


export default ResourceDataDisplay